function isWebKitBrowser() {
  const ua = window.navigator.userAgent
  const iOS = !!ua.match(/iPhone/i)
  const webkit = !!ua.match(/WebKit/i)
  return iOS && webkit
}

export default isWebKitBrowser
